import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = () => {
  const { currentUser, loading, logout } = useAuth();
  const location = useLocation();

  // Check token validity on route changes
  useEffect(() => {
    const checkTokenValidity = () => {
      const token = localStorage.getItem("token");

      if (!token) return;

      try {
        // JWT tokens have three parts separated by dots
        const tokenParts = token.split(".");
        if (tokenParts.length !== 3) {
          // Invalid token format
          logout();
          return;
        }

        // The second part contains the payload (in base64)
        const payload = JSON.parse(atob(tokenParts[1]));

        if (payload.exp) {
          const expiryTime = payload.exp * 1000; // Convert to milliseconds
          const currentTime = Date.now();

          if (currentTime >= expiryTime) {
            // Token has expired, logout the user
            logout();
          }
        }
      } catch (e) {
        console.error("Error checking token expiration:", e);
        // If there's an error parsing the token, it might be corrupted
        logout();
      }
    };

    checkTokenValidity();
  }, [location.pathname, logout]); // Re-run on route changes

  // If still loading auth state, show nothing or a spinner
  if (loading) {
    return <div className="text-center p-5">Loading...</div>;
  }

  // If user is not logged in, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // Otherwise, render the protected route
  return <Outlet />;
};

export default PrivateRoute;
